/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-31 13:23:23
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-14 16:47:55
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/DebounceRequestInput/index.tsx
 */
import React from 'react';
import { CompositionInput } from 'src/components/Antd';
import { useAfterDidMountEffect, useDebounce } from 'src/tools/customHooks';

//import { checkSlug } from 'src/request/common';

const DebounceRequestInput = (props) => {
  const {
    value,
    onChange,
    displayDangerousNotice,
    fixedParams,

    isValid,
    customError,
    customHelper,
    filter,
    maxLength,
    checkFunction,
    valueKey = 'queryContent',
    invalidHelper,
    disabled,
  } = props;
  const [slugText, setSlugText] = React.useState(value || ''); //是不是可以去掉？
  const [valid, setValid] = React.useState(isValid);
  const [validated, setValidated] = React.useState(true);

  const handleOnChange = () => {
    if (onChange && (slugText !== value || isValid !== valid)) {
      onChange({
        text: slugText,
        valid,
      });
    }
  };
  // React.useEffect(() => {
  //   sendReq(); //初始值娇艳
  // }, []);

  const sendReq = () => {
    if (slugText && checkFunction) {
      checkFunction({ ...(fixedParams || {}), [valueKey]: slugText }).then(
        (res) => {
          setValid(!res);
          setValidated(true);
        },
      );
    }
  };

  const handleOnSlugChange = (slug, e) => {
    setSlugText(slug);
  };

  useAfterDidMountEffect(() => {
    //父级改变同步数据
    if (value !== slugText) {
      setSlugText(value);
    }
  }, [value]);

  const debouncedValue = useDebounce<string>(slugText, 200);

  useAfterDidMountEffect(() => {
    handleOnChange();
  }, [valid]);

  useAfterDidMountEffect(() => {
    if (!slugText) {
      //当空时是对的
      setValid(true);
      setValidated(true);
      handleOnChange();
    } else {
      setValidated(false);

      if (!valid) {
        handleOnChange();
      }
    }
  }, [slugText]);

  useAfterDidMountEffect(() => {
    if (!validated) {
      setValid(false);
    }
  }, [validated]);

  useAfterDidMountEffect(() => {
    sendReq();
  }, [debouncedValue]);

  return (
    <CompositionInput
      size='large'
      help={
        customError
          ? customHelper
          : invalidHelper || 'A page already exists with the same url slug.'
      }
      error={(displayDangerousNotice && validated && !valid) || customError}
      maxLength={maxLength || 30}
      onChange={handleOnSlugChange}
      customFilter={filter}
      value={slugText}
      disabled={disabled}
    />
  );
};
export default DebounceRequestInput;
